<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable" v-if="identityList.length">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">識別碼</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">登入類型</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">啟動狀態</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">更新時間</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">建立時間</th>
          </tr>
          </thead>
          <tbody>
          <tr class="even" role="row" v-for="(identity, index) in identityList">
            <td>
              {{index + 1}}
            </td>
            <td>{{identity.identity}}</td>
            <td>
              <span v-if="identity.type == 1"><img class="img-login-type img-round" src="/static/img/icon/matcher.png"></span>
              <span v-if="identity.type == 2"><img class="img-login-type img-round" src="/static/img/icon/fb.png"></span>
              <span v-if="identity.type == 3"><img class="img-login-type img-round" src="/static/img/icon/google.png"></span>
              <span v-if="identity.type == 4"><img class="img-login-type img-round" src="/static/img/icon/line.png"></span>
            </td>
            <td>
              <span v-if="identity.is_active" class="label label-success">啟動</span>
              <span v-if="!identity.is_active"  class="label label-danger">未啟動</span>
            </td>
            <td>{{identity.edit_time}}</td>
            <td>{{identity.create_time}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>

export default{
  data () {
    return {
      identityList: []
    }
  },
  methods: {
    getIdentityList () {
      var self = this
      var url = '/shopper/' + this.$route.params.shopper_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.identityList = response.data.shopper_info.identity_list
        }
      })
    }
  },
  created () {
    this.getIdentityList()
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>



// WEBPACK FOOTER //
// MemberIdentityTableTemp.vue?52bbb6ec